module.exports = __webpack_public_path__ + "img/ic_back.0d03dc2c.svg";